import { render } from "./SimpleLayout.vue?vue&type=template&id=1c9367f8"
const script = {}

import exportComponent from "/Users/keita/Develop/infonic/infpf-adminsite/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__